import {CustomModal} from '_metronic/partials/modals/CustomModal'
import {FC, useState} from 'react'

type Props = {
  isModalOpen: boolean
  hideModal: () => void
  url: string
}

const ShareLinkModal: FC<Props> = ({isModalOpen, hideModal, url}) => {
  const [isCopied, setIsCopied] = useState(false)

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={hideModal}
      title='Share Trust Center'
      isCloseIconShown={true}
    >
      <div>
        <div className='input-group'>
          <input type='text' className='form-control' value={url} readOnly />

          <span className='input-group-text'>
            {isCopied ? (
              <div className='d-flex align-items-center justify-content-center text-dark gap-2'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='18'
                  height='18'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='M5 12l5 5l10 -10' />
                </svg>
                <span>Copied</span>
              </div>
            ) : (
              <button
                className='btn btn-flush'
                onClick={async () => {
                  await navigator.clipboard.writeText(url)
                  setIsCopied(true)
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='18'
                  height='18'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z' />
                  <path d='M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1' />
                </svg>

                <span className='ms-2'>Copy Link</span>
              </button>
            )}
          </span>
        </div>
      </div>
    </CustomModal>
  )
}

export default ShareLinkModal
